/* Move the existing discount field; keep one input and preserve desktop placement. */
(() => {
 if(window.brzCartCodePlacement) return;
 window.brzCartCodePlacement=true;
 const mq=window.matchMedia('(max-width:760px)');
 function place(){
  const field=document.querySelector('.form-cart .brz-cart-code');
  const box=document.querySelector('.brz-mobile-order-box');
  if(!field||!box)return;
  let home=document.querySelector('.brz-cart-code-home');
  if(!home){home=document.createElement('span');home.className='brz-cart-code-home';home.hidden=true;field.before(home);}
  const button=box.querySelector('.brz-acces-rapide');
  if(mq.matches&&button&&field.parentElement!==box)box.insertBefore(field,button);
  else if(!mq.matches&&field.parentElement!==home.parentElement)home.after(field);
 }
 let queued=false;
 new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;place();});}}).observe(document.documentElement,{childList:true,subtree:true});
 mq.addEventListener('change',place);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',place);else place();
})();